import { z } from 'zod';

const playerSchema = z.object({
  login: z.string().min(1),
  profileName: z.string().nullish(),
  avatarUrl: z.string().nullish(),
  selectedAvatarUrl: z.string().nullish(),
  selectedFrameUrl: z.string().nullish(),
  // Backend field is already available; SDK 0.8.0 types do not include it yet.
  selectedFrameId: z.string().nullish(),
  place: z.number().int().positive(),
  exp: z.number().int().nonnegative(),
  level: z.number().int().positive().nullish(),
  totalExp: z.number().int().nonnegative().nullish(),
});
export const rankingsSchema = z.object({
  data: z
    .array(
      playerSchema.transform((player) => ({
        ...player,
        avatarUrl: player.selectedAvatarUrl?.trim() || player.avatarUrl?.trim() || undefined,
      })),
    )
    .max(100),
  period: z.enum(['all', 'week']),
  timezone: z.string(),
  generatedAt: z.string(),
});
